import React, { useCallback, useContext } from 'react';
import { FunctionComponent } from 'react';
import { CalendarNextButton } from '../CalendarNextButton';
import { CalendarPreviousButton } from '../CalendarPreviousButton';
import { CalendarContext } from '../../contexts/CalendarContext';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { useActiveMonth } from '../../hooks';

export type CalendarPaginationNextButtonProps = {
    nextMonthStart: Date;
    nextMonthEnd: Date;
    timezone: string;
    locale: string;
    onClick: () => void;
};

export type CalendarPaginationPreviousButtonProps = {
    previousMonthStart: Date;
    previousMonthEnd: Date;
    timezone: string;
    locale: string;
    onClick: () => void;
};

export type CalendarPaginationProps = {
    className?: string;
    NextButton?: FunctionComponent<CalendarPaginationNextButtonProps>;
    PreviousButton?: FunctionComponent<CalendarPaginationPreviousButtonProps>;
};

export const CalendarPagination: FunctionComponent<CalendarPaginationProps> = ({
    className,
    NextButton = CalendarNextButton,
    PreviousButton = CalendarPreviousButton,
}) => {
    const { locale, timezone, setActiveDate } = useContext(CalendarContext);
    const previousMonth = useActiveMonth(-1);
    const nextMonth = useActiveMonth(1);

    const onPreviousClick = useCallback(() => {
        setActiveDate(previousMonth.range.from);
    }, [setActiveDate, previousMonth]);

    const onNextClick = useCallback(() => {
        setActiveDate(nextMonth.range.from);
    }, [setActiveDate, nextMonth]);

    return (
        <div className={classNames(styles.pagination, className)}>
            <PreviousButton
                previousMonthStart={previousMonth.range.from}
                previousMonthEnd={previousMonth.range.to}
                locale={locale}
                timezone={timezone}
                onClick={onPreviousClick}
            />
            <NextButton
                nextMonthStart={nextMonth.range.from}
                nextMonthEnd={nextMonth.range.to}
                locale={locale}
                timezone={timezone}
                onClick={onNextClick}
            />
        </div>
    );
};
